import React, { useState } from 'react';
import './Contact.css'; // Import the CSS file
import GoogleMap from './GoogleMap';
import { BiHome } from 'react-icons/bi';
import { MdEmail } from 'react-icons/md';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import { LuPhoneCall } from "react-icons/lu";
import { Link } from 'react-router-dom';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission (e.g., send data to server or use a service like EmailJS)
    console.log('Form submitted:', formData);
  };

  return (
    <div className="contact-container">
      <div className="about-hero">
        <div className="hero-overlay">
          <h1 className="hero-heading">Contact Us</h1>
          <p className="hero-subheading"></p>
          <br />
          <div className="back-link">
             <Link to="/">
              <span>Home</span>
            </Link>
            <span>/</span>
            <span>Contact Us</span>
         </div>
        </div>
      </div>
      

      <div className="contact-content">
        {/* Contact Information Section */}
        <div className="contact-info">
        <div className="contact-info-content">
          <h2>Get In Touch With Us</h2>
          <p className='reach'> You can also reach out to us by phone or email are many variations</p>

          <div className='details-of-contact'>
         <span>< LuPhoneCall /></span>
         <p>
            <strong>Phone:</strong><br /> <br /> +234 802 387 9629
          </p>
         </div>
          <div className='details-of-contact'>
            <span>
                <BiHome />
            </span>
          <p>
            <strong>Address:</strong><br /> <br /> 12 Alade Street, Igbobi, Lagos, Nigeria
          </p>
          </div>
         <div className='details-of-contact'>
            <span><MdEmail/></span>
         <p>
             <strong>Email:</strong><br /> <br /> info@adcoreconsulting.com
          </p>
         </div>
          <div className="social-iconss">
            <Link to="https://facebook.com" className="--icon">
              <FaFacebook/>
            </Link>
            <Link to="https://twitter.com"  className="--icon">
              <FaTwitter/>
            </Link>
            <Link to="https://instagram.com"  className="--icon">
              <FaInstagram/>
            </Link>
          </div>
        </div>
        </div>

        {/* Contact Form Section */}
        <div className="contact-form">
          <h3>Send Us a Message</h3>
          <form onSubmit={handleSubmit}>
      
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder='Name'
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
                data-aos="zoom-out"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder='Phone Number'
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
                data-aos="zoom-out"

              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder='SubJect'
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
                data-aos="zoom-out"

              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder='Email'
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
                data-aos="zoom-out"
              />
            </div>
            <div className="form-text">
              <textarea
                name="message"
                placeholder='Message'
                value={formData.message}
                onChange={handleChange}
                required
                className="form-textarea"
                data-aos="zoom-out"
              />
            </div>
                <button type="submit" className="submit-button" data-aos="zoom-in">
              Send Message
            </button>
          </form>
        </div>
      </div>
      <GoogleMap/>
    </div>
  );
};

export default Contact;
